<template>
  <div>
    <div class="google-map" ref="map"></div>
    <template v-if="googleMapLoaded">
      <slot :google="google" :map="map"></slot>
    </template>
  </div>
</template>

<script>
import googleMapsApiLoader from 'google-maps-api-loader'
export default {
  props: {
    mapConfig: Object
  },
  data () {
    return {
      google: null,
      map: null
    }
  },
  computed: {
    googleMapLoaded () {
      return this.google && this.map
    }
  },
  async mounted () {
    this.google = await googleMapsApiLoader({
      apiKey: 'AIzaSyBSNxqCl5Fcbe9ehF9KIDj5ypNQQuh6DF4',
      libraries: ['places']
    })
    this.initMap()
  },
  methods: {
    initMap () {
      const config = Object.assign({
        disableDefaultUI: true,
        zoomControl: true,
        zoom: 14,
        center: {
          lat: 37.393326,
          lng: 126.970475
        }
      }, this.mapConfig)
      this.map = new this.google.maps.Map(this.$refs.map, config)

      this.map.addListener('click', (e) => {
        this.$emit('click', e.latLng)
      })
      this.$emit('load', {
        google: this.google,
        map: this.map
      })
    },
    fitBounds (posArray = []) {
      if (!this.map) return
      if (!posArray.length) return
      const padding = 0.003
      const b = new this.google.maps.LatLngBounds()

      posArray.forEach(v => {
        const pos = new this.google.maps.LatLng(v)
        b.extend(pos)
      })

      const pointa = b.getNorthEast()
      const pointb = b.getSouthWest()

      function distance (a, b) {
        const pa = JSON.parse(JSON.stringify(a))
        const pb = JSON.parse(JSON.stringify(b))
        const ax = pa.lng
        const ay = pa.lat
        const bx = pb.lng
        const by = pb.lat

        const x = Math.abs(ax - bx)
        const y = Math.abs(ay - by)

        return Math.sqrt((Math.pow(x, 2) + Math.pow(y, 2)))
      }

      if (distance(pointa, pointb) < padding) {
        const extendPoint1 = new this.google.maps.LatLng(b.getNorthEast().lat() + padding, b.getNorthEast().lng() + padding)
        const extendPoint2 = new this.google.maps.LatLng(b.getNorthEast().lat() - padding, b.getNorthEast().lng() - padding)
        b.extend(extendPoint1)
        b.extend(extendPoint2)
      }

      this.map.fitBounds(b)
    }
  }
}
</script>

<style>
.google-map {
  height: 100%;
}
</style>
